import GameControlButton from "@/Components/GameControlButton"
import { useBackgroundMusicPreference } from "@/Hooks/useBackgroundMusicPreference"
import classNames from "classnames"

interface BackgroundMusicToggleProps {
  className?: string
  testId?: TestId
}

const BackgroundMusicToggle: React.FC<BackgroundMusicToggleProps> = ({
  className,
  testId = "background-music-toggle",
}) => {
  const { enabled, toggle } = useBackgroundMusicPreference()

  return (
    <GameControlButton
      accent="cyan"
      onClick={toggle}
      data-testid={testId}
      aria-label={enabled ? "Turn music off" : "Turn music on"}
      className={classNames("!px-0 !py-0", className)}
    >
      <span className="relative flex h-full w-full items-center justify-center">
        <i className="fa-solid fa-music fa-lg mobile:!text-[13px]"></i>
        {!enabled && (
          <span
            className="pointer-events-none absolute left-1/2 top-1/2 h-[2px] w-[130%] -translate-x-1/2 -translate-y-1/2 rotate-45 rounded-full bg-current shadow-[0_0_2px_rgba(0,0,0,0.8)]"
            aria-hidden="true"
          />
        )}
      </span>
    </GameControlButton>
  )
}

export default BackgroundMusicToggle
